module.exports = __webpack_public_path__ + "static/media/a4lg.042b9747.png";